import { Component, Input, HostListener } from '@angular/core'
import { Form } from '../Dto/Form';
import { OnInit, OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { FormElement } from '../Dto/FormElement';
import { DynamicFormElement } from '../Dto/DynamicFormElement';
import { Question } from '../Dto/Question';
import { Label } from '../Dto/Label';
import { Consent } from '../Dto/Consent';
import { QuestionChoice } from '../Dto/QuestionChoice';
import { FormGroup, FormControl, Validators, FormBuilder, ValidatorFn } from '@angular/forms';
import { Section } from '../Dto/Section';
import { Inject } from '@angular/core';
import { FormsService } from '../services/form.service';
import { FormAnswer } from '../Dto/FormAnswer';
import { QuestionAnswer } from '../Dto/QuestionAnswer';
import { element } from 'protractor';
import { FileAnswer } from '../Dto/FileAnswer';
import { Router, ActivatedRoute } from '@angular/router';
import { ConsentAnswer } from '../Dto/ConsentAnswer';
import { ValidationErrors } from '@angular/forms/src/directives/validators';
import { AbstractControl } from '@angular/forms/src/model';
import { ForbiddenDateValidatorDirective } from './ForbiddenDateValidatorDirective';
import { RecruitmentProjectsService } from '../services/recruitment-projects.service';
import { RecruitmentSourceService } from '../services/recruitment-source.service';
import { RecruitmentProject } from '../Dto/RecruitmentProject';
import { EntryLogs } from '../services/entry-logs.service';
import { CandidateEntry } from '../Dto/CandidateEntry';
import { RecrutiationSource } from '../Dto/RecrutationSource';

import { tick } from '@angular/core/testing';
import { environment } from '../../environments/environment';
import { ApplicationInsightsService } from '../services/application-insights.service';

@Component({
  selector: 'form-app',
  templateUrl: './formVisualizer.component.html',
  providers: [FormsService, RecruitmentProjectsService, RecruitmentSourceService, EntryLogs],
  styleUrls: ['../app.component.css']
})

export class FormVisualizer implements OnInit, OnDestroy {
  formService: FormsService;
  fb: FormBuilder;
  model = new RecrutiationSource();
  form: Form;
  entry: CandidateEntry = new CandidateEntry();

  guid;

  formGroup: FormGroup;
  formAnswer: FormAnswer = new FormAnswer();
  allQuestions: DynamicFormElement[] = new Array<DynamicFormElement>();
  optionQuestions: DynamicFormElement[] = new Array<DynamicFormElement>();
  recruitmentProject: RecruitmentProject;


  ready: boolean = false;
  formReady: boolean = false;
  afterSubmit: boolean = false;
  error: boolean = false;
  disabled: boolean = false;
  filelimit: boolean = false;
  correctFileExtension: boolean = true;
  progress: boolean = false;
  notActive: boolean = false;
  formStarted: boolean = false;
  extensions: String[] = ['doc', 'docx', 'pdf', 'odt', 'xps', 'txt', 'pages', 'jpg', 'png', 'jpeg'];

  dataObject;
  objectProps;

  saveCandidateEntryUrl = environment.settings.apiEndpoint + '/api/RecruitmentRedirect/SaveCandidateEntry';

  theSections: { Section: Section, Array: DynamicFormElement[], string: String }[] = [];
  fileUpload: Map<string, FileAnswer> = new Map<string, FileAnswer>();

  constructor(@Inject(FormBuilder) fb: FormBuilder, formService: FormsService, private router: Router, private route: ActivatedRoute, private recruitmentProjService: RecruitmentProjectsService, private recruitmentSourceService: RecruitmentSourceService, private entryLogsService: EntryLogs, private applicationInsightsService: ApplicationInsightsService) {
    this.fb = fb;
    this.formService = formService;
    this.guid = this.route.snapshot.paramMap.get('guid');
    this.entry.wasError = false;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload($event) {
    this.entry.dateOut = new Date(Date.now());
    this.applicationInsightsService.trackEvent("CandidateWindowUnload");
    setTimeout(() => { }, 2000);
    const params =
      "?dateOut=" + encodeURIComponent(this.entry.dateOut.toJSON()) +
      "&dateEntry=" + encodeURIComponent(this.entry.dateEntry.toJSON()) +
      "&submitted=" + (this.entry.sumbittedForm ? 'true' : 'false') +
      "&url=" + encodeURIComponent(this.entry.url) +
      "&iP=" + encodeURIComponent(this.entry.iP || '') +
      "&error=" + (this.entry.wasError ? 'true' : 'false');

    navigator.sendBeacon(this.saveCandidateEntryUrl + params);
  }

  @HostListener('window:onunload', ['$event'])
  ununload($event) {
    $event.returnValue = "Saved";
  }

  ngOnInit() {
    this.entry.dateEntry = new Date(Date.now());
    this.entry.url = this.route.snapshot['_routerState'].url;
    this.entryLogsService
      .getIp()
      .subscribe(ip => {
        if (ip.length <= 15) {
          this.entry.iP = ip;
        } else {
          throw new Error("IP is not a valid ipv4 address, please check ip service")
        }
      });
    this.entryLogsService
      .saveEntry(this.route.snapshot.paramMap.get('guid'))
      .subscribe(x => { }, err => { this.error = true; this.ready = false; });

    this.formService
      .getForm(this.guid)
      .subscribe(data => {
        this.form = data;
        if (data === null || data === undefined || this.form.recruitmentProjectId === 0) {
          this.error = true;
        }
        else if (!data.isActive || data.isDeleted) {
          this.notActive = true;
        }
        else {
          this.recruitmentProjService.getRecruitmentProject(this.form.recruitmentProjectId).subscribe(x => {
            this.form.sections = data.sections.sort((x1, x2) => x1.order - x2.order);
            for (let i = 0; i < this.form.sections.length; i++) {

              this.theSections.push({
                Section: this.form.sections[i],
                Array: this.toDynamicFormElelements(this.form.sections[i].formElements),
                string: 'fg' + i
              });
            }
            this.formGroup = new FormGroup(this.prepare());
            this.optionQuestions.forEach(x => x.value = '');
            this.recruitmentProject = x;

            var refferer = document.referrer;
            if (refferer.includes("source=Indeed")) {
              this.model.guid = this.guid;
              this.model.recruitmentProjectId = this.recruitmentProject.recruitmentProjectId;
              this.model.recruitmentProjectName = this.recruitmentProject.position;
              this.recruitmentSourceService.saveIndeedSource(this.model).subscribe(x => {
                this.model = x[0];
              });
            }
            this.ready = true;
          })
        }

      },
        err => { this.error = true; }
      );

  }

  ngOnDestroy(): void {
    this.entry.dateOut = new Date(Date.now());
    this.entryLogsService.saveCandidateEntry(this.entry).subscribe(x => { });
  }

  onFileUpload(event, key: string) {
    this.onEntryChanged();
    // this.formGroup.get(key).setValue(null);
    this.fileUpload.delete(key);
    this.fileUpload[key] = null;
    this.disabled = true;
    this.filelimit = false;
    this.correctFileExtension = true;

    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      var controlType: string[] = file.name.split('.');
      var type = controlType[controlType.length - 1].toLowerCase();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (!this.extensions.includes(type)) {
          this.formGroup.get(key).setValue(null);
          this.correctFileExtension = false;
          this.disabled = false;
        }

        else if (file.size <= 7340032 && file.size > 0) {
          let fileA = new FileAnswer();
          fileA.fileData = (reader.result as string).split(',')[1] as any;
          fileA.fileName = file.name;
          fileA.contentType = file.type;
          fileA.questionId = Number(key.replace('q', ''));
          fileA.questionText = this.allQuestions.find(x => x.key == key).label;

          this.fileUpload[key] = fileA;
          this.disabled = false;
          this.formGroup.get(key).updateValueAndValidity();
          this.applicationInsightsService.trackEvent("CandidateFormFileUpload");
        }

        else {
          this.formGroup.get(key).setValue(null);
          this.filelimit = true;
          this.disabled = false;
        }

      };
    }
    this.disabled = false;
  }

  private prepare(): any {
    this.dataObject = this.toDynamicFormElelement(this.form);
    this.objectProps =
      Object.keys(this.dataObject)
        .map(prop => {
          return Object.assign({}, { key: prop }, this.dataObject[prop]);
        });

    const formGroup = {};
    for (let prop of Object.keys(this.dataObject)) {
      if (prop.includes('q') || prop.includes('c'))
        formGroup[prop] = new FormControl(this.dataObject[prop].value, this.mapValidators(this.dataObject[prop].validation));
    }

    return formGroup;
  }

  private mapValidators(validators) {
    const formValidators = [];
    if (validators) {
      for (const validation of Object.keys(validators)) {
        if (validation === 'required') {
          formValidators.push(Validators.required);
        } else if (validation === 'min') {
          formValidators.push(Validators.min(validators[validation]));
        }
      }
    }
    return formValidators;
  }

  private toDynamicFormElelements(elements: FormElement[]): DynamicFormElement[] {
    let dynamics = new Array<DynamicFormElement>();
    for (let i = 0; i < elements.length; i++) {
      let newDynamic = new DynamicFormElement();
      if (elements[i].type == "Question") {
        newDynamic.key = 'q' + ((<Question>elements[i]).questionId == 0 ? elements[i].id : (<Question>elements[i]).questionId);
        newDynamic.label = (<Question>elements[i]).questionText;
        newDynamic.type = this.toType((<Question>elements[i]));
        if (newDynamic.type == 'text') {
          var cnt = (<Question>elements[i]).rowCount;
          newDynamic.rowCount = cnt;
        } if (newDynamic.type == 'open') {
          newDynamic.rowCount == (<Question>elements[i]).rowCount;
        }
        if ((<Question>elements[i]).isRequired)
          newDynamic.require = (<Question>elements[i]).isRequired;
        if (newDynamic.type == "file") {
          newDynamic.fileType = this.toAccept((<Question>elements[i]).fileType);
          newDynamic.value = null;
          //  newDynamic.validation = { fileValidator: newDynamic.fileType, fileInputValidator: (<Question>elements[i]).isRequired };
        }
        newDynamic.value = '';
        if (newDynamic.type == 'datetodate') {
          newDynamic.key = 'q' + ((<Question>elements[i]).questionId == 0 ? elements[i].id : (<Question>elements[i]).questionId) + "a";
          dynamics.push(newDynamic);
          this.allQuestions.push(newDynamic);

          newDynamic = new DynamicFormElement();
          newDynamic.type = this.toType((<Question>elements[i]));
          newDynamic.key = 'q' + ((<Question>elements[i]).questionId == 0 ? elements[i].id : (<Question>elements[i]).questionId) + "b";
          if ((<Question>elements[i]).isRequired)
            newDynamic.validation = { required: (<Question>elements[i]).isRequired };
          newDynamic.value = null;
        }
        if ((<Question>elements[i]).questionChoices != null && (<Question>elements[i]).questionChoices.length > 0) {
          newDynamic.options = this.toOptions((<Question>elements[i]).questionChoices);
          this.optionQuestions.push(newDynamic);
        }

      }
      else if (elements[i].type == "Label") {
        newDynamic.key = 'l' + ((<Label>elements[i]).labelId == 0 ? elements[i].id : (<Label>elements[i]).labelId);
        newDynamic.label = (<Label>elements[i]).text;
        newDynamic.type = '';

      } else {
        newDynamic.key = 'c' + ((<Consent>elements[i]).consentId == 0 ? elements[i].id : (<Consent>elements[i]).consentId);
        newDynamic.options.push({ label: (<Consent>elements[i]).text, key: "o" + (<Consent>elements[i]).consentId, check: false });
        newDynamic.value = '';
        if ((<Consent>elements[i]).isRequired)
          newDynamic.validation = { required: (<Consent>elements[i]).isRequired };
        newDynamic.type = 'checkbox';
        newDynamic.value = null;
      }
      dynamics.push(newDynamic);
      this.allQuestions.push(newDynamic);
    }
    return dynamics;
  }

  private toDynamicFormElelement(form: Form): Map<string, DynamicFormElement> {
    const dynamics = new Map<string, DynamicFormElement>();
    for (const section of form.sections) {
      const elements = section.formElements;
      for (const element of elements) {
        let newDynamic = new DynamicFormElement();
        if (element.type == "Question") {
          newDynamic.label = (<Question>element).questionText;
          if ((<Question>element).questionChoices != null && (<Question>element).questionChoices.length > 0) {
            newDynamic.options = this.toOptions((<Question>element).questionChoices);
            newDynamic.type = this.toType((<Question>element));
          } else
            newDynamic.type = this.toType((<Question>element));
          if (newDynamic.type == 'open') {
            newDynamic.rowCount == (<Question>element).rowCount;
          }
          if ((<Question>element).isRequired)
            newDynamic.validation = { required: (<Question>element).isRequired };

          if (newDynamic.type == "file") {
            newDynamic.fileType = this.toAccept((<Question>element).fileType);
            newDynamic.value = null;
            //  newDynamic.validation = { fileValidator: newDynamic.fileType, fileInputValidator:(<Question>element).isRequired };
          }
          newDynamic.value = '';
          if (newDynamic.type.includes('date')) {
            newDynamic.value = null;
          }
          newDynamic.key = 'q' + ((<Question>element).questionId == 0 ? element.id : (<Question>element).questionId);
          newDynamic.order = element.order;
          if (newDynamic.type == 'datetodate') {
            newDynamic.key = 'q' + ((<Question>element).questionId == 0 ? element.id : (<Question>element).questionId) + "a";
            dynamics[newDynamic.key] = newDynamic;
            newDynamic = new DynamicFormElement();
            newDynamic.type = this.toType((<Question>element));
            newDynamic.key = 'q' + ((<Question>element).questionId == 0 ? element.id : (<Question>element).questionId);
            if ((<Question>element).isRequired)
              newDynamic.validation = { required: (<Question>element).isRequired };
            newDynamic.value = null;
            newDynamic.key += "b";
          }
        }
        else if (element.type == "Label") {
          newDynamic.key = 'l' + ((<Label>element).labelId == 0 ? element.id : (<Label>element).labelId);
          newDynamic.label = (<Label>element).text;
          newDynamic.type = '';
          newDynamic.order = element.order;

        } else {
          newDynamic.key = 'c' + ((<Consent>element).consentId == 0 ? element.id : (<Consent>element).consentId);
          newDynamic.options.push({ label: (<Consent>element).text, key: "o" + (<Consent>element).consentId, check: false });
          if ((<Consent>element).isRequired)
            newDynamic.validation = { required: (<Consent>element).isRequired };
          newDynamic.type = 'text';
          newDynamic.value = null;
          newDynamic.order = element.order;
        }
        dynamics[newDynamic.key] = newDynamic;
      }
    }
    return dynamics;
  }

  updateValidity(key: string) {
    this.onEntryChanged();
    this.formGroup.get(key.replace('a', 'b')).updateValueAndValidity();
  }

  private toOptions(choices: QuestionChoice[]): { key: string, label: string, check: boolean }[] {
    let options = new Array<{ key: string, label: string, check: boolean }>();
    let i = 0;
    choices.forEach(x => {
      options.push({ label: x.choice, key: "o" + i++, check: false });
    })
    return options;
  }

  private toType(question: Question): string {
    switch (question.questionType) {
      case 'onechoice': return 'radio';
      case 'salary': return question.questionChoices.length > 0 ? 'radio' : 'text';
      case 'multichoice': return 'checkbox';
      case 'list': return 'list';
      case 'file': return 'file';
      case 'date': return 'date';
      case 'datetodate': return 'datetodate';
      case 'email': return 'email';
      case 'phone': return 'tel';
      case 'open': return 'text';
      case 'nameSurname': return 'name';
      case 'name': return 'name';
      case 'surname': return 'name';
      case 'city': return 'city';
      default: return 'text';
    }
  }

  private toAccept(oldType: string): string {
    switch (oldType) {
      case 'pdf': return 'application/pdf';
      case 'zdjęcie': return 'image/png, image/jpg';
      case 'word': return 'application/msword, .doc, .docx,';
      case 'excel': return 'application/vnd.ms-excel,.xls,.xlsx';
      default: return '';
    }
  }

  public fromFileType(oldType: string): string {
    switch (oldType) {
      case 'application/pdf': return 'pdf';
      case 'image/png, image/jpg': return 'zdjęcie';
      case 'application/msword, .doc, .docx,': return 'word';
      case 'application/vnd.ms-excel,.xls,.xlsx': return 'excel';
      default: return '';
    }
  }

  onOptionChange(key: string, value: boolean, option: string) {
    this.onEntryChanged();
    if (value)
      this.optionQuestions.find(x => x.key == key).value = option;
    else {
      this.optionQuestions.find(x => x.key == key).value = '';
    }
  }

  onCheckBoxChange(key: string, value: boolean, option: string) {
    this.onEntryChanged();
    if (value)
      this.optionQuestions.push()
  }

  onSubmit(firm: any) {
    this.applicationInsightsService.trackEvent("CandidateFormSubmitted");

    if (!this.formGroup.valid) {
      this.applicationInsightsService.trackEvent("CandidateFormInvalid");
      Object.keys(this.formGroup.controls).forEach(key => {
        this.formGroup.controls[key].markAsDirty();
        this.formGroup.controls[key].markAsTouched();
        this.formReady = true;
      });
      return;
    }
    this.formAnswer = new FormAnswer();
    var isValidAnswer = true;
    this.applicationInsightsService.trackEvent("CandidateFormValid");
    this.formReady = false;
    this.progress = true;
    this.formAnswer.formId = this.form.formId;

    //@TODO: Change to ?? once typescript is up-to-date
    this.formAnswer.recruitmentSourceGuid = this.model.guid || this.guid;

    //Filter out 'o' and labels @CHECK: What's 'o'?
    const formControls = Object.entries(this.formGroup.controls)
      .filter(([key, _]) => !(key.includes('o') || key.includes('l')));

    for (const [key, control] of formControls) {
      const question = this.allQuestions.find(x => x.key == key);
      const controlKey = key[0];
      //If it's a consent
      if (controlKey == 'c') {
        let consent = new ConsentAnswer();
        if (control.value != null && control.value == true) {
          consent.consentId = Number(key.replace('c', ''));
          consent.text = question.options[0].label;
          this.formAnswer.consentAnswers.push(consent);
        }
      }
      //If it's a question
      else if (controlKey == 'q') {
        const questionAnswer = new QuestionAnswer();
        questionAnswer.answer = '';
        const questionType = key[key.length - 1];
        if (questionType === 'a') {
          if (control.value != null) {
            const value = control.value;
            questionAnswer.answer = value.day + "-" + value.month + "-" + value.year + " do ";
          }
        }
        else if (questionType === 'b') {
          const newK = key.replace('b', '').replace('q', '');

          if (control.value != null) {
            let ans = control.value.day + "-" + control.value.month + "-" + control.value.year;
            if (this.formAnswer.questionAnswers.find(x => x.questionId == Number(newK)) != null) {
              this.formAnswer.questionAnswers.find(x => x.questionId == Number(newK)).answer += ans;
            }
          }
        }
        else if (question.type == 'file') {
          const fileUpload = this.fileUpload[key];
          if (fileUpload != null && fileUpload.fileData != null)
            this.formAnswer.fileAnswers.push(fileUpload);
        }
        else if (question.type == 'date') {
          if (control.value != null)
            questionAnswer.answer = control.value.day + "-" + control.value.month + "-" + control.value.year;
        }
        else if (question.options != null && question.options.length > 0) {
          if (question.type == 'checkbox') {
            for (const optionQuestion of this.optionQuestions.find(x => x.key == key).options) 
            {
              if (optionQuestion.check) {
                questionAnswer.answer += optionQuestion.label + ';';
              }
            }
          }
          else if (question.type == 'list') questionAnswer.answer = this.formGroup.get(key).value;
          else questionAnswer.answer = this.optionQuestions.find(x => x.key == key).value;
        }
        else if (question.type == 'city' || question.type == 'name' || question.type == 'surname') {
          var answer = control.value.trim().replace(/\s+/g, ' ');
          if(answer == '' && question.require){            
            control.markAsDirty();
            control.markAsTouched();
            control.setErrors({empty:true});
            isValidAnswer = false;            
          }
          questionAnswer.answer = answer;
        }
        else {
          questionAnswer.answer = control.value;
        }

        questionAnswer.questionId = Number(key.replace('q', '').replace('a', '').replace('b', ''));
        questionAnswer.questionText = question.label || this.optionQuestions.find(x => x.key == key).label;

        if (questionAnswer.answer != '')
          this.formAnswer.questionAnswers.push(questionAnswer);
      }
      else throw `Unexpected control key: ${controlKey}`;
    };

    if (!isValidAnswer) {
      this.applicationInsightsService.trackEvent("CandidateFormInvalid");      
      this.formReady = true;
      this.progress = false;      
      return;
    }

    this.formService
      .saveForm(this.formAnswer)
      .subscribe(
        x => {
          this.afterSubmit = true;
          this.entry.sumbittedForm = true;
        },
        err => {
          this.applicationInsightsService.trackEvent("CandidateFormSendingFailure");
          this.error = true;
          this.entry.wasError = true;
        });
    this.formGroup.reset();
  }

  public onEntryChanged() {
    if (!this.formStarted) {
      this.formStarted = true;
      this.applicationInsightsService.trackEvent("CandidateFormEntryStarted");
    }
  }
}
